const Reducer = (state: any, action: any) => {
  switch (action.type) {
    case "SET_ERROR":
      return {
        ...state,
        error: action.payload,
      };
    case "SET_ISUSERLOGGEDIN":
      return {
        ...state,
        isUserLoggedIn: action.payload,
      };
    case "SET_ROLE":
      return {
        ...state,
        role: action.payload,
      };
    case "SET_MSALINSTANCE":
      return {
        ...state,
        msalInstance: action.payload,
      };
    case "SET_USER":
      return {
        ...state,
        user: action.payload,
      };
    case "SET_ACTIVE_COST_CENTER":
      if (action.payload?.costCenterId) {
        localStorage.setItem("active-cost-center-id", action.payload.costCenterId);
        localStorage.setItem("active-cost-center-name", action.payload.costCenterName || "");
      } else {
        localStorage.removeItem("active-cost-center-id");
        localStorage.removeItem("active-cost-center-name");
      }
      return {
        ...state,
        activeCostCenterId: action.payload?.costCenterId || null,
        activeCostCenterName: action.payload?.costCenterName || null,
      };
    default:
      return state;
  }
};

export default Reducer;
